import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TourDateChangeService } from '../../pages/immo-ip/tour/tour-page/service/tour-date-change.service';
import { SubscriptionBasedComponent } from '../../subscription-helpers/subscription-based.component';
import * as timezone from 'moment-timezone';
import Employee from '../../model/product/employee';
import { RequestService } from '../../services/request.service';
import { ImmoStudioAssign } from '../../model/tour/immo-studio-assign';
import { ImmoStudioTour } from '../../model/tour/immo-studio-tour';
import * as moment from 'moment';
import { SnackService } from '../../services/snack.service';
import { SubProjectControllerRequestService } from '../../services/api/sub-project-controller-request.service';
import { Tour } from '../../model/tour/tour';

@Component({
  selector: 'immo-studio-assign-modal',
  templateUrl: './immo-studio-assign-modal.component.html',
  styleUrls: ['./immo-studio-assign-modal.component.scss'],
})
export class ImmoStudioAssignModalComponent
  extends SubscriptionBasedComponent
  implements OnInit
{
  @Input()
  tour: ImmoStudioTour | Tour;

  @Input()
  showCenter: boolean = false;

  @Output()
  atelierAssigneeChanged = new EventEmitter<void>();

  loading: boolean;

  atelierEmployeeId: number;
  atelierDate: Date;
  reviewEmployeeId: number;
  reviewDate: Date;
  atelierSequence: number;

  savedAtelierEmployeeId: number;
  savedAtelierDate: moment.Moment;
  savedReviewEmployeeId: number;
  savedReviewDate: moment.Moment;

  assignOptions: Employee[] = [];

  constructor(
    private snackService: SnackService,
    private requestService: RequestService,
    private tourDateChangeService: TourDateChangeService,
    private subProjectService: SubProjectControllerRequestService
  ) {
    super();
  }

  ngOnInit() {
    this.loading = true;
    this.initAtelierSubscriptions();
    this.getEmployees();
  }

  private initAtelierSubscriptions() {
    this.addSubscription(
      this.tourDateChangeService.getAtelierDateSubject(),
      (date) => {
        if (date != null) {
          this.savedAtelierDate = date.toDate();
        }
      }
    );

    this.addSubscription(
      this.tourDateChangeService.getReviewDateSubject(),
      (date) => {
        if (date != null) {
          this.savedReviewDate = date.toDate();
        }
      }
    );

    this.addSubscription(
      this.tourDateChangeService.getAtelierEmployeeId(),
      (id) => {
        this.savedAtelierEmployeeId = id;
      }
    );

    this.addSubscription(
      this.tourDateChangeService.getReviewEmployeeId(),
      (id) => {
        this.savedReviewEmployeeId = id;
      }
    );
  }

  private getEmployees() {
    this.addSubscription(
      this.requestService.get('employees/withType/ATELIER'),
      (result) => {
        const atelierEmployees = <Employee[]>result.body;
        this.assignOptions = atelierEmployees.sort(function (a, b) {
          if (a.user.firstName > b.user.firstName) {
            return 1;
          } else if (a.user.firstName < b.user.firstName) {
            return -1;
          }

          if (a.user.lastName > b.user.lastName) {
            return 1;
          } else if (a.user.lastName < b.user.lastName) {
            return -1;
          } else {
            return 0;
          }
        });
        this.assignTour(this.tour);
      }
    );
  }

  updateAtelierEmployeeId(): void {
    this.tourDateChangeService
      .getAtelierEmployeeId()
      .next(this.atelierEmployeeId);
  }

  updateReviewEmployeeId(): void {
    this.tourDateChangeService
      .getReviewEmployeeId()
      .next(this.reviewEmployeeId);
  }

  updateAtelierDate(): void {
    const tz = timezone(this.atelierDate).tz('Europe/Brussels').locale('nl-BE');
    this.tourDateChangeService.getAtelierDateSubject().next(tz);
  }

  updateReviewDate(): void {
    const tz = timezone(this.reviewDate).tz('Europe/Brussels').locale('nl-BE');
    this.tourDateChangeService.getReviewDateSubject().next(tz);
  }

  public submitAssign() {
    const assignDto = new ImmoStudioAssign();
    assignDto.tourId = this.tour.id;
    assignDto.atelierDate = timezone(this.atelierDate)
      .tz('Europe/Brussels')
      .locale('nl-BE')
      .unix();
    assignDto.reviewDate = timezone(this.reviewDate)
      .tz('Europe/Brussels')
      .locale('nl-BE')
      .unix();
    assignDto.atelierEmployeeId = this.atelierEmployeeId;
    assignDto.reviewEmployeeId = this.reviewEmployeeId;
    assignDto.atelierSequence = this.atelierSequence;
    this.subProjectService.updateImmoStudioAssignees(assignDto).then(() => {
      this.atelierAssigneeChanged.emit();
    });
  }

  public assignTour(tour?: ImmoStudioTour | Tour) {
    if (tour) {
      if (this.assignOptions.length === 0) {
        this.snackService.showWarning(
          'Er zijn geen Atelier medewerkers ingesteld'
        );
        return;
      }

      const firstEmployeeId = this.assignOptions[0].id;
      this.reviewEmployeeId =
        tour.reviewEmployee != null
          ? tour.reviewEmployee.id
          : this.savedReviewEmployeeId != null
          ? this.savedReviewEmployeeId
          : firstEmployeeId;
      this.atelierEmployeeId =
        tour.atelierEmployee != null
          ? tour.atelierEmployee.id
          : this.savedAtelierEmployeeId != null
          ? this.savedAtelierEmployeeId
          : firstEmployeeId;
      this.reviewDate =
        tour.reviewDate != null
          ? tour.reviewDate
          : this.savedReviewDate != null
          ? moment(this.savedReviewDate).toDate()
          : new Date();
      this.atelierDate =
        tour.atelierDate != null
          ? tour.atelierDate
          : this.savedAtelierDate != null
          ? moment(this.savedAtelierDate).toDate()
          : new Date();
      this.atelierSequence =
        tour.atelierSequence != null ? tour.atelierSequence : 10;
      this.loading = false;
    }
  }
}
